import { FC, useEffect, useState } from 'react';
import { PropertyType, PropertyTypesCheck, PropertyTypesTitle } from '../styles';

interface CheckboxSingleProps {
  name: string;
  value: string | string[];
  handleSetSelected: (type: string, value: string | string[]) => void;
  selectedArr?: string[];
  type: string;
}

export const CheckboxSingle: FC<CheckboxSingleProps> = ({
  name,
  value,
  handleSetSelected,
  selectedArr,
  type,
}) => {
  const [selected, setSelected] = useState(false);

  const isValueSelected = (selectedArr: string[], value: string[]): boolean => {
    return value?.every((item) => selectedArr?.includes(item));
  };

  useEffect(() => {
    const tmpValue = Array.isArray(value) ? value : [value];
    setSelected(isValueSelected(selectedArr ?? [], tmpValue));
  }, [selectedArr]);

  const handleSetSelectedSingle = (): void => {
    handleSetSelected(type, value);
  };
  const dataTestId = `${name.toLowerCase().split(' ').join('-')}`;
  return (
    <PropertyType onClick={handleSetSelectedSingle}>
      <PropertyTypesCheck
        type="checkbox"
        data-testid={selected ? `${dataTestId}-checked` : `${dataTestId}-unchecked`}
        checked={selected}
        onChange={handleSetSelectedSingle}
      />
      <PropertyTypesTitle data-testid={`${dataTestId}-filter`}>{name}</PropertyTypesTitle>
    </PropertyType>
  );
};
